import React, { useEffect, useState } from "react";
import ImageAbout from "../../assets/images/kids-dash-image.jpg";
import LogoKidsDash from "../../assets/images/kids-dash-logo.png";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import API_URL from "../../config/constant";

export default function AboutKidsDash() {
  const { t } = useTranslation();
  const [aboutData, setAboutData] = useState(null);
  const locale = useSelector((state) => state.locale.locale);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await fetch(`${API_URL}/kids-dash?lang=${locale}`);
        if (!response.ok) throw new Error("Data not found");
        const data = await response.json();
        if (data.about === null) throw new Error("Data not found");
        setAboutData(data.about);
      } catch (error) {
        setAboutData(t("kidsDash.about", { returnObjects: true }));
      }
    };

    fetchAboutData();
  }, [t, locale]);

  return (
    <div className="bg-black text-white font-ttFirsNeue pt-20 md:pt-28 relative overflow-x-hidden">
      {/* Hero image */}
      <div className="w-full max-w-full overflow-hidden">
        <img
          src={ImageAbout}
          alt=""
          className="w-full max-w-full object-cover"
        />
      </div>

      {/* Logo */}
      <div className="w-full flex justify-center py-8">
        <img
          src={LogoKidsDash}
          alt=""
          className="w-[180px] md:w-[260px] max-w-full object-contain"
        />
      </div>

      {/* Content */}
      <div className="px-6 md:px-20 pb-20 space-y-14 max-w-full overflow-hidden break-words">
        <AboutSection
          title={aboutData?.about.title}
          content={aboutData?.about.content}
        />

        <AboutSection
          title={aboutData?.winner.title}
          content={aboutData?.winner.content}
        />

        <AboutSection
          title={aboutData?.registration.title}
          content={aboutData?.registration.content}
        />
      </div>
    </div>
  );
}

function AboutSection({ title, content }) {
  return (
    <div className="space-y-6 max-w-full overflow-hidden break-words">
      <h1 className="text-2xl md:text-4xl font-bold tracking-wide text-[#F79838] uppercase">
        {title}
      </h1>

      <div
        className="text-base md:text-lg leading-relaxed space-y-5 opacity-90
                           [&>ul]:list-disc [&>ul]:pl-6 [&>ul>li]:mb-2
                           max-w-full break-words"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
}
